export class ConfigsSiebel {

    constructor(
        public siebelEndpoint?: string,
		public siebelFaleconoscoTipoOrigem?: string,
		public siebelFaleconoscoRamoOrigem?: string,
		public siebelFaleconoscoProduto?: string,
		public siebelFaleconoscoUsername?: string,
		public siebelFaleconoscoPassword?: string,
		public siebelFaleconoscoTipoSessao?: string,
		public siebelOuvidoriaTipoOrigem?: string,
		public siebelOuvidoriaRamoOrigem?: string,
		public siebelOuvidoriaProduto?: string,
		public siebelOuvidoriaUsername?: string,
		public siebelOuvidoriaPassword?: string,
		public siebelOuvidoriaTipoSessao?: string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/configs-siebel.ts